import moment from "moment";
import "moment-timezone";

export const columns = [
  { accessorKey: "serialNumber", header: "Serial #", size: 150 },
  { accessorKey: "registrationNumber", header: "Vehicle", size: 140 },
  { accessorKey: "containerNumber", header: "container", size: 155 },

  { accessorKey: "vehicleStatus", header: "Status", size: 130 },
  { accessorKey: "vehicleType", header: "Type", size: 120 },
  { accessorKey: "consignmentType", header: "Consignment", size: 180 },
  {
    accessorKey: "cargoTypeName",
    header: "Cargo",
    size: 130,
    accessorFn: (row: any) => ` ${row.cargoTypeName || " "}`,
  },
  { accessorKey: "terminalLocation", header: "Location", size: 150 },
  {
    accessorKey: "anomly",
    header: "Anomaly",
    sortable: true,
    size: 150,
  },
  {
    accessorKey: "secondaryInspection",
    header: "Secondary Insp",
    size: 200,
    accessorFn: (row: any) => ` ${row.secondaryInspection || " "}`,
  },
  {
    accessorKey: "startTime",
    header: "Start Time",
    sortable: true,
    size: 165,
    accessorFn: function customCell(row: any) {
      return `${row.startTime ? moment(row.startTime).format("DD-MM-YYYY hh:mm:ss A") : ""}`;
    },
  },
  {
    accessorKey: "endTime",
    header: "End Time",
    sortable: true,
    size: 155,
    accessorFn: function customCell(row: any) {
      return `${row.endTime ? moment(row.endTime).format("DD-MM-YYYY hh:mm:ss A") : ""}`;
    },
  },
  {
    accessorKey: "vehicleInProgress",
    header: "In Progress ",
    size: 170,
    type: "boolean",
  },
  {
    accessorKey: "refNum",
    header: "Reference #",
    size: 170,
    accessorFn: (row: any) => ` ${row.refNum || " "}`,
  },
  {
    accessorKey: "comment",
    header: "Possible Issues",
    size: 200,
    accessorFn: (row: any) => ` ${row.comment || " "}`,
  },
  {
    accessorKey: "remarks",
    header: "Remarks",
    size: 150,
    accessorFn: (row: any) => ` ${row.remarks || " "}`,
  },
  {
    accessorKey: "files",
    header: "Files",
    size: 130,
    accessorFn: (row: any) => ` ${row.files || " "}`,
  },
  {
    accessorKey: "actions",
    header: "Actions",
    size: 220,
    accessorFn: (row: any) => ` ${row.actions || " "}`,
  },
];
